// CSS media queries use the layout viewport, including a classic scrollbar.
// Keep Australian lowcode overrides on the same breakpoint when a modal locks
// scrolling; preserve the existing visual viewport behavior for other sites.
export function resolveResponsiveViewportWidth({
  templateKey,
  visualWidth,
  innerWidth,
  clientWidth,
} = {}) {
  const preferredWidth = templateKey === 'australia' ? innerWidth : visualWidth
  return Math.round(preferredWidth || innerWidth || clientWidth || 1200)
}
